const images2 = [
  {
    imgURL:
      "https://m.media-amazon.com/images/I/71JFOtO2ZuL._AC_SY200_.jpg",
    imgAlt: "img-1"
  },
  {
    imgURL:
      "https://m.media-amazon.com/images/I/71jID7kxyrL._AC_SY200_.jpg",
    imgAlt: "img-2"
  },
  {
    imgURL:
      "https://m.media-amazon.com/images/I/610Jl4dUB7L._AC_SY200_.jpg",
    imgAlt: "img-2"
  },
  {
    imgURL:
      "https://m.media-amazon.com/images/I/71Ryl5xKbuL._AC_SY200_.jpg",
    imgAlt: "img-3"
  },
 
  {
    imgURL:
      "https://m.media-amazon.com/images/I/61lrpyxMNQL._AC_SY200_.jpg",
    imgAlt: "img-1"
  },

];

export default images2;
